var map = {
	"./codesports.svg": "sd/s",
	"./flag-adelaide.svg": "UWl8",
	"./flag-brisbane.svg": "aRRb",
	"./flag-carlton.svg": "9jhq",
	"./flag-collingwood.svg": "EgdP",
	"./flag-essendon.svg": "/+Uv",
	"./flag-fremantle.svg": "CVkz",
	"./flag-geelong.svg": "+HxS",
	"./flag-goldcoast.svg": "rcF7",
	"./flag-gws.svg": "cMil",
	"./flag-hawthorn.svg": "nh0X",
	"./flag-melbourne.svg": "1DDd",
	"./flag-northmelbourne.svg": "0v+/",
	"./flag-portadelaide.svg": "DhLk",
	"./flag-richmond.svg": "u27w",
	"./flag-stkilda.svg": "Nn3O",
	"./flag-sydney.svg": "aseJ",
	"./flag-westcoast.svg": "l+Sa",
	"./flag-westernbulldogs.svg": "Pwtv",
	"./header.svg": "v8Uc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 1